<template>
  <div class="square">
    <div class="square_header">
      <!-- <div class="header_item" @click="Areashow = true">
        <van-icon name="location" size=".36rem" color="#FF410A" />
        <div class="line1">{{ AreaName || "地区" }}</div>
        <van-icon class="icon" color="#999999" name="arrow-down" />
      </div> -->
      <div class="header_item" @click="hangyeShow = true">
        <div>
          <span :class="hangye.length != 0 ? 'active' : ''">{{
            hangye.length == 0 ? "行业" : "多选"
          }}</span>
        </div>
        <van-icon class="icon" color="#999999" name="arrow-down" />
        <!-- <van-icon class="icon" color="#999999" name="play" /> -->
      </div>
      <div class="header_item" @click="xuqiuShow = true">
        <div>需求</div>
        <van-icon class="icon" color="#999999" name="arrow-down" />
        <!-- <van-icon class="icon" color="#999999" name="play" /> -->
      </div>
    </div>
    <div class="info">
      <div class="info_top">
        <div>
          <img :src="userInfo.avatar" />
          <span>{{ userInfo.nickname }}</span>
        </div>
        <div class="tag">展示中</div>
      </div>
      <div class="info_bottom">
        {{ userInfo.personality }}
      </div>
    </div>
    <!-- <div class="project">
      <div class="project_top">
        <img src="../../../assets/images/ava1 (2).png" />
        <div class="line1">个人信用卡账单处理系统</div>
      </div>
      <img class="project_icon" src="../../../assets/images/project_icon.png" />
      <div class="project_bottom">
        <div class="bottom_top line2">
          教你1000还5万，2000还10万，重点当天还清所有信用卡账单。
        </div>
        <div class="bottom_bottom">
          <span>#大健康 · 美容美妆</span>
          <span>已推荐5110人，33人感兴趣</span>
        </div>
      </div>
    </div> -->
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      finished-text="没有更多了"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div
        class="list_item"
        v-for="(item, index) in list"
        :key="index"
        @click.stop="goPage(item)"
      >
        <div class="item_top">
          <div class="item_top_left">
            <img :src="item.avatar" />
            <!-- <span>在线</span> -->
          </div>
          <div class="item_top_center">
            <div class="line1">
              {{ item.nickname }}
            </div>
            <div class="line1">{{ item.DemandName.demand_name }}</div>
          </div>
          <div class="item_top_right">
            <div class="item_btn" @click.stop="hello(item)">打招呼</div>
          </div>
        </div>
        <div class="item_bottom line2">
          {{ item.personality }}
        </div>
      </div>
    </van-list>
    <van-popup position="bottom" round v-model="Areashow">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        value="110101"
        @cancel="Areashow = false"
        @confirm="selectArea"
      />
    </van-popup>
    <van-popup class="hangye_pop" position="bottom" round v-model="hangyeShow">
      <div class="hangye_top">
        选择你的行业
        <van-icon
          class="hangye_close"
          color="#999999"
          name="cross"
          @click="hangyeShow = false"
        />
      </div>
      <div class="hangye_list">
        <div
          class="hangye_list_box"
          v-for="(item, index) in cateList"
          :key="index"
        >
          <div class="hangye_title">{{ item.cat_title }}</div>
          <div class="hangye_box">
            <div
              :class="
                value.clecked == true ? 'hangye_item active' : 'hangye_item'
              "
              v-for="(value, index) in item.child"
              :key="index"
              @click="selectHangYe(value.id)"
            >
              {{ value.cat_title }}
            </div>
          </div>
        </div>
      </div>
      <div class="hangye_btn">
        <div class="btn_item" @click="deleteHangYe">重置</div>
        <div class="btn_item sub" @click="submit">确定</div>
      </div>
    </van-popup>
    <van-popup class="xuqiu_pop" position="bottom" round v-model="xuqiuShow">
      <div class="xuqiu_top">
        为你推荐精准人脉
        <van-icon
          class="xuqiu_close"
          color="#999999"
          name="cross"
          @click="xuqiuShow = false"
        />
      </div>
      <div class="xuqiu_list">
        <div class="item_title">你是</div>
        <div class="item_list">
          <div
            :class="item.is_click == 1 ? 'item active' : 'item'"
            v-for="(item, index) in demandList.youre"
            :key="index"
            @click="seclectXuQiu(0, item.id)"
          >
            {{ item.demand_name }}
          </div>
        </div>
        <div class="item_title">你想</div>
        <div class="item_list">
          <div
            :class="item.is_click == 1 ? 'item active' : 'item'"
            v-for="(item, index) in demandList.would_you"
            :key="index"
            @click="seclectXuQiu(1, item.id)"
          >
            {{ item.demand_name }}
          </div>
        </div>
      </div>
      <div class="xuqiu_btn">
        <div class="btn_item" @click="deleteXuQiu">重置</div>
        <div class="btn_item sub" @click="submit">确定</div>
      </div>
    </van-popup>
    <van-popup class="hello_pop" closeable v-model="helloPop">
      <div class="pop_top">
        <img :src="item.avatar" alt="" />
        <div class="pop_top_right">
          <div class="pop_name">{{ item.nickname }}</div>
        </div>
      </div>
      <div class="pop_bottom">
        <div class="pop_btn" @click.stop="openTel">
          {{ item.phone || "未设置电话" }}
        </div>
        <div class="pop_btn" @click.stop="openWeixin">
          {{ item.wx_qr_code != "" ? "微信" : "未设置微信" }}
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="Weixinshow">
      <div class="item_img">
        <img :src="item.wx_qr_code" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Icon, List, Popup, Area, Dialog, Toast, Cell, CellGroup } from "vant";
import { areaList } from "@vant/area-data";
import { getCity, getArticleCateLstNew, getFollowLstNew } from "@/api/public";
import { getDemandList, getContacts } from "@/api/lcapi";
import { getUser } from "@api/user";
export default {
  name: "Square",
  components: {
    [Icon.name]: Icon,
    [List.name]: List,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
    [Area.name]: Area,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      list: [],
      error: false,
      loading: false,
      finished: false,
      Areashow: false,
      areaList,
      AreaName: "",
      hangyeShow: false,
      hangye: [],
      xuqiuShow: false,
      cateList: "",
      demandList: "",
      xuqiu: [],
      limit: 10,
      total: "",
      userInfo: "",
      helloPop: false,
      item: "",
      Weixinshow: false,
    };
  },
  mounted() {
    getUser().then((res) => {
      this.userInfo = res.data;
    });

    getFollowLstNew().then((res) => {
      console.log(res.data);
      // res.data.cate.forEach((item) => {
      //   this.hangye.push(item.pid);
      // });
      getArticleCateLstNew().then((res) => {
        let cateList = res.data;
        // cateList.forEach((item) => {
        //   item.child.forEach((value) => {
        //     let index = this.hangye.indexOf(value.id);
        //     if (index != -1) {
        //       value.clecked = true;
        //     } else {
        //       value.clecked = false;
        //     }
        //   });
        // });
        this.cateList = cateList;
      });
      getDemandList()
        .then((res) => {
          let demandList = res.data;
          // demandList.would_you.forEach((item) => {
          //   if (item.is_click == 1) {
          //     this.xuqiu.push(item.id);
          //   }
          // });
          // demandList.youre.forEach((item) => {
          //   if (item.is_click == 1) {
          //     this.xuqiu.push(item.id);
          //   }
          // });
          this.demandList = demandList;
        })
        .then(() => {
          // this.onLoad();
        });
    });
  },
  methods: {
    /**
     * 跳转微站
     */
    goPage(item) {
      console.log(item);
      this.$router.push({
        path: "/jiaodian/userWeizhan?uid=" + item.uid,
      });
    },
    /**
     * 获取列表数据
     */
    onLoad() {
      const that = this;
      let hangye = JSON.stringify(this.hangye).replace(/\[|]/g, "");
      let xuqiu = JSON.stringify(this.xuqiu).replace(/\[|]/g, "");
      getContacts({
        page: 1,
        limit: that.limit,
        link_id: hangye,
        demand_id: xuqiu,
      })
        .then((res) => {
          that.total = res.data.total || 0;
          that.list = res.data;
          // 加载状态结束
          that.loading = false;
          that.limit = that.limit + 10;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
        });
    },
    /**
     * 选择地区
     */
    selectArea(e) {
      console.log(e);
      this.AreaName = e[1].name;
      this.Areashow = false;
    },
    /**
     * 选择行业
     */
    selectHangYe(id) {
      this.cateList.forEach((element, index) => {
        element.child.forEach((item, idx) => {
          if (item.id == id) {
            if (item.clecked) {
              let ids = this.hangye.indexOf(item.id);
              this.hangye.splice(ids, 1);
            } else {
              this.hangye.push(item.id);
            }
            item.clecked = !item.clecked;
          }
        });
      });
    },
    /**
     * 重置行业
     */
    deleteHangYe() {
      this.hangye = [];
      this.cateList.forEach((element) => {
        element.child.forEach((item) => {
          item.clecked = false;
        });
      });
    },
    /**
     * 需求选择
     */
    seclectXuQiu(type, id) {
      if (type == 0) {
        this.demandList.youre.forEach((item) => {
          if (item.id == id) {
            if (item.is_click == 1) {
              item.is_click = 0;
              let index = this.xuqiuActive.indexOf(item.id);
              this.xuqiu.splice(index, 1);
            } else {
              item.is_click = 1;
              this.xuqiu.push(item.id);
            }
          }
        });
      } else if (type == 1) {
        this.demandList.would_you.forEach((item) => {
          if (item.id == id) {
            if (item.is_click == 1) {
              item.is_click = 0;
              let index = this.xuqiuActive.indexOf(item.id);
              this.xuqiu.splice(index, 1);
            } else {
              item.is_click = 1;
              this.xuqiu.push(item.id);
            }
          }
        });
      }
    },
    /**
     * 重置需求
     */
    deleteXuQiu() {
      console.log(this.xuqiu);
      this.xuqiu = [];
      console.log(this.xuqiu);
      this.demandList.would_you.forEach((item) => {
        item.is_click = 0;
      });
      this.demandList.youre.forEach((item) => {
        item.is_click = 0;
      });
    },
    /**
     * 确定
     */
    submit() {
      this.hangyeShow = false;
      this.xuqiuShow = false;
      this.limit = 10;
      this.onLoad();
    },
    /**
     * 打招呼
     */
    hello(item) {
      this.item = item;
      console.log(item);
      this.helloPop = true;
      // if (item.phone == null || item.phone == "" || item.phone) {
      //   Toast({ message: "暂无对方联系方式" });
      // } else {
      //   // this.helloPop = true;
      // }
    },
    /**
     * 查看电话
     */
    openTel() {
      if (this.item.phone == null || this.item.phone == "" || item.phone)
        return;
      Dialog.alert({
        title: "电话",
        message: this.item.phone,
      }).then(() => {
        // on close
      });
    },
    openWeixin() {
      if (
        this.item.wx_qr_code == null ||
        this.item.wx_qr_code == "" ||
        item.wx_qr_code
      )
        return;
      this.Weixinshow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.square {
  padding-top: 0.9rem;
  .square_header {
    background: #ffffff;
    display: flex;
    align-items: center;
    height: 0.9rem;
    line-height: 0.9rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #f5f5f5;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 2000;
    .header_item {
      margin-right: 0.4rem;
      display: flex;
      align-items: center;
      div {
        font-size: 0.3rem;
        padding-right: 0.05rem;
        max-width: 1rem;
        text-align: right;
      }
      .active {
        color: #ff410a;
      }

      .icon {
        // transform: rotateZ(90deg);
      }
    }
  }
  .info {
    padding: 0.4rem 0.3rem;
    background: #ffffff;
    .info_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0;
      div {
        display: flex;
        align-items: center;
        font-size: 0;
        img {
          width: 0.9rem;
          height: 0.9rem;
          border-radius: 50%;
          margin-right: 0.2rem;
        }
        span {
          font-size: 0.32rem;
          color: #1b1b1b;
          font-weight: bold;
        }
      }
      .tag {
        font-size: 0.34rem;
        color: #ff410a;
      }
    }
    .info_bottom {
      margin-top: 0.3rem;
      font-size: 0.3rem;
      color: #1b1b1b;
    }
  }
  .project {
    margin-top: 0.2rem;
    padding: 0.4rem 0.3rem;
    background: #ffffff;
    position: relative;
    .project_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0;
      width: calc(100% - 1.5rem);
      img {
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 50%;
      }
      div {
        width: calc(100% - 0.9rem);
        font-size: 0.32rem;
        color: #1b1b1b;
        font-weight: bold;
        padding-left: 0.2rem;
      }
    }
    .project_icon {
      width: 1.5rem;
      height: 1.5rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    .project_bottom {
      margin-top: 0.1rem;
      .bottom_top {
        font-size: 0.3rem;
      }
      .bottom_bottom {
        margin-top: 0.1rem;
        font-size: 0.26rem;
        color: #999999;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .list {
    margin-top: 0.2rem;
    .list_item {
      background: #ffffff;
      padding: 0.2rem 0.3rem;
      margin-top: 0.2rem;
      .item_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item_top_left {
          position: relative;
          width: 0.9rem;
          img {
            width: 0.9rem;
            height: 0.9rem;
          }
          span {
            display: inline-block;
            width: 100%;
            background: #f5f5f5;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 0.2rem;
            height: 0.4rem;
            line-height: 0.4rem;
            text-align: center;
            color: #979596;
            font-size: 0.2rem;
          }
        }
        .item_top_center {
          width: calc(100% - 2.2rem);
          padding-left: 0.2rem;
          div {
            line-height: 0.45rem;
            &:first-child {
              font-size: 0.32rem;
              font-weight: bold;
            }
            &:last-child {
              color: #999999;
              font-weight: 400;
              font-size: 0.26rem;
            }
          }
        }
        .item_top_right {
          width: 1.3rem;
          height: 0.5rem;
          background: #ff410a;
          border-radius: 0.06rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.26rem;
          color: #ffffff;
        }
      }
      .item_bottom {
        margin-top: 0.1rem;
        font-size: 0.3rem;
      }
    }
  }
  .hangye_pop {
    max-height: 60vh;
    .hangye_top {
      text-align: center;
      height: 1.3rem;
      line-height: 1.3rem;
      font-weight: bold;
      font-size: 0.42rem;
      position: fixed;
      width: 100%;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
      .hangye_close {
        position: absolute;
        right: 0.3rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .hangye_list {
      margin-top: 1.3rem;
      max-height: calc(60vh - 2.9rem);
      padding: 0 0.3rem 0.2rem 0.3rem;
      overflow: auto;
      .hangye_list_box {
        .hangye_title {
          font-size: 0.3rem;
          padding: 0.2rem 0 0 0;
        }
        .hangye_box {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .hangye_item {
            width: calc((100% - 0.4rem) / 3);
            height: 0.7rem;
            border: 0.01rem solid #e5e5e5;
            line-height: 0.68rem;
            text-align: center;
            font-size: 0.26rem;
            margin-top: 0.2rem;
            border-radius: 0.06rem;
            margin-right: 0.2rem;
            background: #f6f6f6;
            &:nth-child(3n + 3) {
              margin-right: 0;
            }
            &.active {
              background: #fff8f6;
              border-color: #ff410a;
              color: #ff410a;
            }
          }
        }
      }
    }
    .hangye_btn {
      height: 1.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.3rem;
      padding-bottom: 0.4rem;
      margin-top: 0.3rem;
      .btn_item {
        width: calc((100% - 0.2rem) / 2);
        text-align: center;
        line-height: 0.9rem;
        border-radius: 0.06rem;
        background: #f6f6f6;
        font-size: 0.34rem;
        font-weight: bold;
        &.sub {
          background: #ff410a;
          color: #ffffff;
        }
      }
    }
  }
  .xuqiu_pop {
    max-height: 60vh;
    .xuqiu_top {
      height: 1rem;
      line-height: 1rem;
      font-weight: bold;
      font-size: 0.3rem;
      position: fixed;
      width: 100%;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
      padding-left: 0.3rem;
      .xuqiu_close {
        position: absolute;
        right: 0.3rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .xuqiu_list {
      max-height: calc(60vh - 2.6rem);
      margin-top: 1.3rem;
      padding: 0 0.3rem 0.2rem 0.3rem;
      overflow: auto;
      .item_title {
        font-size: 0.3rem;
        padding: 0.2rem 0 0 0;
      }
      .item_list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .item {
          width: calc((100% - 0.4rem) / 3);
          height: 0.7rem;
          border: 0.01rem solid #e5e5e5;
          line-height: 0.68rem;
          text-align: center;
          font-size: 0.26rem;
          margin-top: 0.2rem;
          border-radius: 0.06rem;
          margin-right: 0.2rem;
          background: #f6f6f6;
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          &.active {
            background: #fff8f6;
            border-color: #ff410a;
            color: #ff410a;
          }
        }
      }
    }
    .xuqiu_btn {
      height: 1.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.3rem;
      padding-bottom: 0.4rem;
      margin-top: 0.3rem;
      .btn_item {
        width: calc((100% - 0.2rem) / 2);
        text-align: center;
        line-height: 0.9rem;
        border-radius: 0.06rem;
        background: #f6f6f6;
        font-size: 0.34rem;
        font-weight: bold;
        &.sub {
          background: #ff410a;
          color: #ffffff;
        }
      }
    }
  }
  .hello_pop {
    padding: 0.3rem;
    width: calc(100% - 1.2rem);
    .pop_top {
      display: flex;
      img {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
      }
      .pop_top_right {
        width: calc(100% - 1.2rem);
        padding-left: 0.2rem;
        .pop_name {
          font-weight: bold;
          font-size: 0.36rem;
        }
      }
    }
    .pop_bottom {
      display: flex;
      justify-content: space-between;
      .pop_btn {
        width: calc((100% - 0.2rem) / 2);
        line-height: 0.8rem;
        text-align: center;
        border: 0.01rem solid #eeeeee;
        border-radius: 0.1rem;
        margin-top: 0.4rem;
        color: #999999;
      }
    }
  }
  .item_img {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%; /*padding-bottom都可以*/
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
